/* TagToys · tienda (todos los kits). Tarjetas grandes con carrusel, índice «Quiero…», vista galería/lista, barra de compra que sigue al kit
   que se ve y encabezado claro/oscuro según el fondo. Sirve igual en el prototipo (tienda.html) y en el tema de Shopify
   (sections/main-tienda.liquid, assets/tienda.js, con defer después de site.js). ?k=esquina abre la página ya en ese kit */
addEventListener("DOMContentLoaded", () => {
  const box = document.getElementById("kits6");
  TT.kitCards(box, Object.keys(TT.KITS));
  TT.vistas(box, document.getElementById("vista6"));
  const ir = TT.quiero(document.getElementById("ask6box"), box);
  // tienda.html?k=esquina abre la página ya en ese kit
  const k = new URLSearchParams(location.search).get("k");
  if (k in TT.KITS) requestAnimationFrame(() => ir(k));
  // la barra de abajo sigue al kit que estás viendo («Agregar al carrito · EL PARCHE · precio», con su combinación de colores);
  // sobre el índice y entre tarjetas vuelve a «Elegir kit»
  const base = { t: "Elegir kit", s: "Envío gratis desde $90.000", href: "#kits6" }, vis = new Map();
  const ioK = new IntersectionObserver(es => {
    es.forEach(e => vis.set(e.target, e.intersectionRatio));
    let mejor = null, r = .4; vis.forEach((v, el) => { if (v > r) { r = v; mejor = el; } });
    if (!mejor) return TT.accion(base);
    const kk = mejor.dataset.k, b = mejor.querySelector("[data-add]");
    TT.accion({ t: "Agregar al carrito", s: `${TT.KITS[kk].name} · ${TT.price(kk)}`, add: b ? b.dataset.add : kk });
  }, { threshold: [0, .2, .4, .6, .8, 1] });
  box.querySelectorAll(".kit6").forEach(c => ioK.observe(c));
  document.querySelectorAll("[data-wa]").forEach(a => a.href = TT.WA);
  // encabezado: claro sobre los bloques negros (videos de clientes, banda de WhatsApp, pie), oscuro sobre el papel
  const hdr = document.getElementById("hdr"); let q = 0, tonoAct = null;
  const tono = () => { q = 0; const el = document.elementsFromPoint(innerWidth / 2, 34).find(x => !x.closest("#hdr")), osc = !!(el && el.closest(".muros6, .band, .foot"));
    if (osc !== tonoAct) { tonoAct = osc; hdr && hdr.classList.toggle("l", !osc); } };
  addEventListener("scroll", () => { if (!q) q = requestAnimationFrame(tono); }, { passive: true }); tono();
  TT.watch();
});
